import { Box } from "@mui/material";
import { useMemo } from "react";
import FlexBox from "../../../../components/layouts/Flexbox";
import { ExpiredTimeChip } from "./ExpiredTimeChip";
import { ExpiredTimesListProps } from "./types";
import { flattenTimesByDate, getSlotTimeLabel } from "./utils";

export function ExpiredTimesList({ pastSlotsByDate }: ExpiredTimesListProps) {
  const expiredTimes = useMemo(
    () => flattenTimesByDate(pastSlotsByDate),
    [pastSlotsByDate]
  );

  if (expiredTimes.length === 0) return null;

  return (
    <Box p={1.25}>
      <FlexBox flexWrap="wrap" gap={0.625}>
        {expiredTimes.map(({ timeKey, dateLabel, time }) => (
          <ExpiredTimeChip
            key={timeKey}
            dateLabel={dateLabel}
            timeLabel={getSlotTimeLabel(time)}
          />
        ))}
      </FlexBox>
    </Box>
  );
}
